module.exports = __webpack_public_path__ + "img/1511416210.42148c5b.jpg";